<div class="user-detail-container">
    <div class="nav-container">
        <button class="btn link-btn btn-back">
            <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectUsers()"></i>
        </button>
        <span class="fw-semibold ms-3">{{'users.add.addUserNavLabel' | translate}}</span>
    </div>

    <form  #form="ngForm">
        <div>
            <ng-container *ngIf="externalProviders.length > 1 && (!user.userId || (user.userId && user.externalProviderId))">
                <div class="row justify-content-center ">
                    <span class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                        <span class="label-input">{{'users.add.externalProviders' | translate}} </span>
                        <span *ngIf="!enableLocalUser" class="text-primary fw-bold">*</span>
                    </span>
                </div>

                <div class="row justify-content-center">
                  <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <kendo-dropdownlist HJSuppress
                                        class="custom-kendo-control-xl"
                                        [fillMode]="fillModeOutline"
                                        [rounded]="roundedLarge"
                                        [size]="sizeLarge"
                                        [data]="externalProviders"
                                        textField="value"
                                        valueField="id"
                                        [valuePrimitive]="true"
                                        name="externalProviders"
                                        [(ngModel)]="user.externalProviderId"
                                        [popupSettings]="{popupClass : 'data-hj-suppress', appendTo : 'component'}"
                                        [disabled]="isDisableExternalProviders"
                                        (change)="externalProviderChange($event)"
                                        [required]="!enableLocalUser">
                    </kendo-dropdownlist>
                  </div>
                </div>
            </ng-container>

            <div class="row justify-content-center mb-3" *ngIf="externalProviders.length === 1 && (!user.userId || (user.userId && user.externalProviderId))">
                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <input
                        class="checkbox-input"
                        type="checkbox"
                        id="hasExternalProvider"
                        name="hasExternalProvider"
                        #hasExternalProvider="ngModel"
                        kendoCheckBox
                        [rounded]="rounded"
                        [size]="size"
                        [(ngModel)]="user.hasExternalProvider"
                        (ngModelChange)="hasExternalProviderChange($event)"
                        [disabled]="isDisableExternalProviders || !enableLocalUser"
                        [required]="!enableLocalUser"
                        >
                    <label for="hasExternalProvider" class="ms-2 cursor-pointer">{{'users.add.useExternalProvider' | translate}} </label>
                </div>
                <div class="error-info" *ngIf="hasExternalProvider.invalid  && (hasExternalProvider.dirty || form.submitted)">
                    <div  *ngIf="hasExternalProvider.errors?.['required']" >
                        {{'common.validation.required' | translate}}
                    </div>
                </div>
            </div>

        </div>

        <div class="form-input-container">
            <div class="row d-flex justify-content-center mb-3" *ngIf="!user.externalProviderId && enableLocalUser">
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3 mb-md-0">
                    <label class="label-input">{{'users.add.firstName' | translate}}<span class="text-primary fw-bold"> *</span></label>
                    <input HJSuppress
                        class="text-input"
                        kendoTextBox
                        name="firstName"
                        #firstName="ngModel"
                        type="text"
                        placeholder="{{ 'users.add.placeholder.firstName' | translate }}"
                        [(ngModel)]="user.firstName"
                        [disabled]="isDisableExternalProviders"
                        required>

                    <div class="error-info" *ngIf="firstName.invalid && (firstName.dirty || form.submitted)">
                        <div *ngIf="firstName.errors?.['required']" >
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3">
                    <label class="label-input">{{'users.add.lastName' | translate}}<span class="text-primary fw-bold"> *</span></label>
                    <input HJSuppress
                        class="text-input"
                        kendoTextBox
                        name="lastName"
                        #lastName="ngModel"
                        type="text"
                        placeholder="{{ 'users.add.placeholder.lastName' | translate }}"
                        [(ngModel)]="user.lastName"
                        required
                        [disabled]="isDisableExternalProviders">

                    <div class="error-info" *ngIf="lastName.invalid && (lastName.dirty || form.submitted)">
                        <div *ngIf="lastName.errors?.['required']" >
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row d-flex justify-content-center mb-3">
                <div [ngClass]="user.externalProviderId || !enableLocalUser ? 'col-md-12 col-lg-10 col-xxl-8 col-xxxl-6' : 'col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 '"
                    class="mb-3 mb-md-0">
                    <label class="label-input">{{'users.add.email' | translate}}<span class="text-primary fw-bold"> *</span></label>
                    <input HJSuppress
                        kendoTextBox
                        name="email"
                        #email="ngModel"
                        class="text-input"
                        type="text"
                        placeholder="{{ 'users.add.placeholder.email' | translate }}"
                        [(ngModel)]="user.email"
                        [pattern]="emailValidator"
                        [disabled]="isDisableExternalProviders || isEmailReadOnly"
                        required>

                    <div class="error-info" *ngIf="email.invalid && (email.dirty || form.submitted)">
                        <div *ngIf="email.errors?.['required']" >
                            {{'common.validation.required' | translate}}
                        </div>

                        <div *ngIf="email.errors?.['pattern']" >
                            {{'common.validation.emailInvalid' | translate}}
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3" *ngIf="!user.externalProviderId && enableLocalUser">
                    <label class="label-input">{{'users.add.phone' | translate}}<span class="text-primary fw-bold"> *</span></label>
                    <input  HJSuppress
                        kendoTextBox
                        name="phone"
                        #phone="ngModel"
                        class="text-input"
                        type="text"
                        placeholder="{{ 'users.add.placeholder.phone' | translate }}"
                        [(ngModel)]="user.phone"
                        required
                        pattern="{{phoneValidator?.regex}}"
                        [disabled]="isDisableExternalProviders"
                    >

                    <div class="error-info" *ngIf="phone.invalid  && (phone.dirty || form.submitted)">
                        <div  *ngIf="phone.errors?.['required']" >
                            {{'common.validation.required' | translate}}
                        </div>

                        <div  *ngIf="phone.errors?.['pattern']">
                            {{'requests.wizard.addDelegateForm.invalidPhone' | translate}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <div class="d-flex flex-column">
                        <div>
                            <input
                                type="checkbox"
                                name="legalRepresentative"
                                id="legalRepresentative"
                                [size]="size"
                                [rounded]="rounded"
                                kendoCheckBox
                                value="greenCardInsurance"
                                [(ngModel)]="user.legalRepresentative">
                            <label for="legalRepresentative" class="ms-2 cursor-pointer">{{'users.add.legalRepresentative' | translate}}</label>
                        </div>
                        <div class="l-spacer"></div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="row justify-content-center">
                <span class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <span class="label-input">{{'users.add.userRights' | translate}} </span>
                    <span class="text-primary fw-bold"> *</span>
                </span>
            </div>
            <div class="row d-flex justify-content-center mb-3">
                <div class="col-sm-6 col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-3 mb-sm-0">
                    <div class="custom-checkbox p-3">
                        <input
                            kendoRadioButton
                            id="fullAccessRight"
                            name="readOnlyRight"
                            #fullAccess="ngModel"
                            type="radio"
                            [size]="size"
                            [(ngModel)]="user.userRightReadOnly"
                            required
                            [value]="false"
                        >
                        <label class="ms-3 cursor-pointer fw-bold" for="fullAccessRight">
                            {{ 'users.add.placeholder.fullAccess' | translate }}
                        </label>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-5 col-xxl-4 col-xxxl-3">
                    <div class="custom-checkbox p-3">
                        <input
                            kendoRadioButton
                            id="readOnlyRight"
                            name="readOnlyRight"
                            #readOnly="ngModel"
                            type="radio"
                            [size]="size"
                            [(ngModel)]="user.userRightReadOnly"
                            required
                            [value]="true"
                        >
                        <label class="ms-3 cursor-pointer fw-bold" for="readOnlyRight">
                            {{ 'users.add.placeholder.readOnly' | translate }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center mb-3">
                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <input
                        type="checkbox"
                        name="acceptEmails"
                        [rounded]="rounded"
                        [size]="size"
                        id="acceptEmails"
                        kendoCheckBox
                        [(ngModel)]="user.acceptEmails">
                    <label for="acceptEmails" class="ms-2 cursor-pointer">{{'users.add.acceptEmails' | translate}}</label>
                </div>
            </div>
            <div class="row justify-content-center mb-3">
                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-centert">
                    <input
                        class="checkbox-input"
                        type="checkbox"
                        name="acceptSms"
                        id="acceptSms"
                        [rounded]="rounded"
                        [size]="size"
                        kendoCheckBox
                        [(ngModel)]="user.acceptSms">
                    <label for="acceptSms" class="ms-2 cursor-pointer">{{'users.add.acceptSms' | translate}}</label>
                </div>
            </div>
            <div class="row justify-content-center mb-3" *ngIf="!user.externalProviderId && enableLocalUser">
                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <input
                        class="checkbox-input"
                        type="checkbox"
                        name="twoFactorAuth"
                        [rounded]="rounded"
                        [size]="size"
                        kendoCheckBox
                        [(ngModel)]="tenantConfiguration.twoFactorAuthentication"
                        disabled
                        >
                    <label for="twoFactorAuth" class="ms-2 cursor-pointer">{{'users.add.twoFactorAuthentication' | translate}}</label>
                </div>
            </div>

            <div class="row justify-content-center mb-3" *ngIf="tenantConfiguration.twoFactorAuthentication && !user.externalProviderId && enableLocalUser">
                <div class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6">
                    <label class="label-input required">
                        {{'users.add.twoFactorAuthenticationType' | translate}}
                    </label>
                    <div class="input-dropdown-container">
                        <kendo-dropdownlist HJSuppress
                            class="custom-kendo-control-xl"
                            #twoFactorAuthType="ngModel"
                            [fillMode]="fillModeOutline"
                            [rounded]="roundedLarge"
                            [size]="sizeLarge"
                            [data]="twoFactorAutenticationTypes"
                            textField="value"
                            valueField="id"
                            [valuePrimitive]="true"
                            name="twoFactorAutenticationTypes"
                            [(ngModel)]="user.dictionaryTwoFactorAuthenticationTypeId"
                            [popupSettings]="{popupClass : 'data-hj-suppress', appendTo : 'component'}"
                            [required]="!user.externalProviderId">
                        </kendo-dropdownlist>
                        <div class="error-info" *ngIf="twoFactorAuthType.invalid  && (twoFactorAuthType.dirty || form.submitted)">
                            <div  *ngIf="twoFactorAuthType.errors?.['required']" >
                                {{'common.validation.required' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mb-3">
                <span class="col-md-12 col-lg-10 col-xxl-8 col-xxxl-6 d-flex align-items-center">
                    <span class="mandatory-fields-label">{{'users.add.fieldsAreMandatory' | translate}}</span>
                </span>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button class="btn primary-btn px-4" (click)="saveUserHandler()" [disabled]="loading">
                <span *ngIf="!this.user?.userId">{{'users.add.addBtn' | translate}}</span>
                <span *ngIf="this.user?.userId">{{'users.add.editBtn' | translate}}</span>
            </button>
        </div>
    </form>
</div>
